import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-icon',
  templateUrl: 'chart-icon.component.html'
})
export class ChartIconComponent {
  constructor() {}
}
